import React from "react";
import clsx from "clsx";

const AppCheckbox = ({
  id,
  label,
  hideLabel = false,
  checked = false,
  onChange,
  disabled = false,
  className = "",
  fontWeight = "medium",
  rest,
}) => {
  return (
    <label
      htmlFor={id}
      className={clsx(
        "relative flex cursor-pointer select-none items-center",
        hideLabel ? "gap-0" : "gap-3",
        disabled && "cursor-not-allowed opacity-60",
        className
      )}
    >
      {/* Hidden native checkbox */}
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="sr-only"
        {...rest}
      />

      {/* Custom checkbox */}
      <span
        className={clsx(
          "w-5 h-5 rounded-md border flex items-center justify-center transition-all",
          checked
            ? "border-blue-500 bg-blue-50"
            : "border-gray-300 bg-white",
        )}
      >
        {checked && (
          <svg
            className="w-4 h-4 text-blue-500"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
      </span>

      {/* Label */}
      {!hideLabel ? (
        <span className={`text-gray-900 text-sm font-${fontWeight}`}>
          {label}
        </span>
      ) : null}
    </label>
  );
};

export default AppCheckbox;
